import { type FC, type ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

import { type PromotionType } from '../../../../algolia'

import { ProductSearchResultItemGenericLabel } from './ProductSearchResultItemGenericLabel'
import { type ProductSearchResultItemLabel } from './useProductSearchResultItemLabels'

const getPromotionLabelByPromotionType = (
  promotionType: PromotionType,
): ReactElement | null => {
  switch (promotionType) {
    case '1+1':
    case 'oneforone': {
      return (
        <ProductSearchResultItemGenericLabel className="border-dark-primary-min bg-light-primary-low text-dark-primary-max">
          <FormattedMessage id="general.label.product.oneforone" />
        </ProductSearchResultItemGenericLabel>
      )
    }
    case 'bundle': {
      return (
        <ProductSearchResultItemGenericLabel className="border-light-primary-strong bg-light-brand-medium">
          <FormattedMessage id="general.label.product.bundle" />
        </ProductSearchResultItemGenericLabel>
      )
    }
    case 'freebie': {
      return (
        <ProductSearchResultItemGenericLabel className="border-dark-primary-min bg-light-primary-low text-dark-primary-max">
          <FormattedMessage id="general.label.product.freebie" />
        </ProductSearchResultItemGenericLabel>
      )
    }
    default: {
      return null
    }
  }
}

export const ProductSearchResultItemPromotionLabelRenderer: FC<{
  label: ProductSearchResultItemLabel
}> = ({ label }) => {
  const promotionType = label.promotionSpecific?.promotionType
  if (!promotionType) {
    return null
  }

  return getPromotionLabelByPromotionType(promotionType)
}
